import { render, staticRenderFns } from "./insertLocal.vue?vue&type=template&id=876687c6&scoped=true&"
import script from "./insertLocal.vue?vue&type=script&lang=js&"
export * from "./insertLocal.vue?vue&type=script&lang=js&"
import style0 from "./insertLocal.vue?vue&type=style&index=0&id=876687c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876687c6",
  null
  
)

export default component.exports